import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(Auth)/layout.js")